// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ModalProvider } from "./context/ModalContext";
import { NotificationProvider } from "./context/NotificationContext";
import ProtectedRoute from "./Components/ProtectedRoute";
import Layout from "./Components/layout/Layout";
import LandingPage from "./pages/LandingPage/LandingPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import SignupPage from "./pages/SignupPage/SignupPage";
import VerifyEmail from "./pages/VerifyEmail/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import Dashboard from "./pages/Dashboardpage/Dashboard";
import Tasks from "./pages/Taskpage/Tasks";
import AddTask from "./pages/AddTaskpage/AddTask";
import AddTaskEnhanced from "./pages/AddTaskpage/AddTaskEnhanced";
import Trackorder from "./pages/Trackorderpage/Trackorder";
import PublicTracking from "./pages/PublicTrackingpage/PublicTracking";
import Settings from "./pages/Settingspage/Settings";
import HelpSupport from "./pages/Helpsupport/Helpsupport";
import Branches from "./pages/Branchpage/Branches";
import AddBranch from "./pages/Branchpage/AddBranch";
import "./App.css";

function App() {
  // Initialize theme on app load
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    document.body.setAttribute('data-theme', savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  return (
    <AuthProvider>
      <NotificationProvider>
      <ModalProvider>
        <Router>
          <Routes>
          {/* Landing page - no layout wrapper */}
          <Route path="/" element={<LandingPage />} />

          {/* Auth pages - no layout wrapper */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Public tracking page - no authentication required */}
          <Route path="/track" element={<PublicTracking />} />
          <Route path="/track/:identifier" element={<PublicTracking />} />

          {/* Dashboard routes - with layout wrapper and protected */}
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/add-task" element={<AddTaskEnhanced />} />
            <Route path="/edit-task/:id" element={<AddTaskEnhanced />} />
            <Route path="/add-task-simple" element={<AddTask />} />
            <Route path="/branches" element={<Branches />} />
            <Route path="/add-branch" element={<AddBranch />} />
            <Route path="/edit-branch/:id" element={<AddBranch />} />
            <Route path="/track-order" element={<Trackorder />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/help-support" element={<HelpSupport />} />
          </Route>
          </Routes>
        </Router>
      </ModalProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
